import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/AboutBusinessUnit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/hero/DesignHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/portfolio/carousel/PortfolioCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/slider/seo/SeoSlider.tsx");
